import { min, sqrt } from "../math.js";
var sqrt3 = sqrt(3);
export default {
    draw: function (context, size) {
        var r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
        var t = r / 2;
        var u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
